import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import NotesPage from './pages/notes';
import './App.css';
import { SettingsPage } from './pages/settings';
import AssignmentsPage from './pages/assignments';
import { StudyPage } from './pages/study';
import { TrialGate } from './pages/trial-gate';
import Signup from './pages/signup';
import LoginLayout from './pages/login';
import { CalendarSettings } from './pages/calendar';
import { SuccessPage } from './pages/success';
import { Upgrade } from './pages/upgrade';
import { Unsubscribe } from './pages/unsubscribe';
import { DiscordSuccess } from './pages/discord-callback';


function App() {
  const search = new URLSearchParams(document.location.search);
  return (
    <>
      <Helmet>
        <title>BetterCampus</title>
        <meta
          name="description"
          content="BetterCampus extension."
        />
        <style>
          {`
          html { background: transparent !important; }
          body { background: transparent !important; }
          #root { background: transparent !important; }
          `}
        </style>
      </Helmet>
      <div className="antialiased min-h-screen font-sans">
        {
          search.has("canvas_url") && (
              <base href={search.get("canvas_url")} />
          )
        }
        <Routes>
          <Route path="/" element={<div>Hello World</div>} />
          <Route path="/notes" element={<NotesPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/assignments" element={<AssignmentsPage />} />
          <Route path="/trial-gate" element={<TrialGate />} />
          <Route path="/study" element={<StudyPage />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<LoginLayout />} />
          <Route path="/calendar" element={<CalendarSettings />} />
          <Route path="/success" element={<SuccessPage />} />
          <Route path="/upgrade" element={<Upgrade />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/discord/success" element={<DiscordSuccess />} />
        </Routes>
      </div>
    </>
  )
}

export default App;